const getTopOffset = top => {
  if (top + 55 > window.innerHeight) return top - 275;
  return top + 55;
};

export default getTopOffset;
